/** @format */

import { Injectable, inject } from '@angular/core';

import { CertonaSchemeItem } from '@shared/data-access/interfaces';
import { HmfProductData } from '@dsg-tech/homefield-angular';
import { Scene7Service } from '@shared/data-access/services';

@Injectable({
	providedIn: 'root'
})
export class RecommendationDataService {
	private readonly scene7Service = inject(Scene7Service);

	mapSchemaItemToProductCardData(item: CertonaSchemeItem, imageSize = 500): HmfProductData {
		if (!item) return null;

		return {
			assetSeoUrl: item.URL,
			ecode: item.ID,
			imageData: {
				imageUrl: this.scene7Service.setImageWidthAndHeight(
					item.ImageURL,
					imageSize,
					imageSize
				)
			},
			pricing: {
				prices: {
					maxListPrice: this.stripExtraDecimals(item.maxlistprice),
					maxOfferPrice: this.stripExtraDecimals(item.maxofferprice),
					minListPrice: this.stripExtraDecimals(item.minlistprice),
					minOfferPrice: this.stripExtraDecimals(item.minofferprice),
					maxMapPrice: this.stripExtraDecimals(item.maxmapprice)
				}
			},
			productName: item.Name
		};
	}

	stripExtraDecimals(price) {
		// Check if the string contains a decimal point
		if (typeof price === 'string' && price.includes('.')) {
			// Split the string into the whole part and the decimal part
			const parts = price.split('.');

			// If there are more than two decimal places, keep only two
			if (parts[1].length > 2) {
				return `${parts[0]}.${parts[1].substring(0, 2)}`;
			}
		}

		return price;
	}
}
